'use strict';

// Este fichero se sube al cliente, por lo cual no usar aqui ninguna librería específica del servidor

////////////////////////////////////////////////////////////////////////////////////////////////////
exports = module.exports = {
	// List of user roles
	//userRoles: ['guest', 'user', 'admin'],
	APP_NAME: "Everlaps"
};



//////////////////
// WEBPACK FOOTER
// ./server/config/environment/shared.js
// module id = 105
// module chunks = 0